import { IUser } from '@giphy/js-types'
import React from 'react'
import styled from 'styled-components'

const getSmallAvatar = (avatar: string) => {
    if (!avatar) return ''
    const ext = avatar
        ?.split('.')
        ?.pop()
        ?.toLowerCase()
    return avatar.replace(`.${ext}`, `/80h.${ext}`)
}

const Img = styled.img`
    object-fit: cover;
    width: 36px;
    height: 36px;
`

type Props = { user: IUser; className?: string }
const Avatar = ({ user, className = '' }: Props) => {
    const url = user.avatar_url ? getSmallAvatar(user.avatar_url) : `https://media.giphy.com/avatars/default0.gif`
    return <Img src={url} className={className} />
}

export default Avatar
